import {BitmapWinCountUp} from "@nolimitcity/slot-game/bin/game/winpresentation/countup/BitmapWinCountUp";
import {Power3, Timeline, TimelineLite, TweenLite} from "gsap";
import {GGSoundConfig} from "../../GGSoundConfig";
import {BitmapTextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/BitmapTextStyleOptions";
import {GGGameModuleConfig} from "../../GGGameModuleConfig";
import {BitmapFontStyleData} from "../../config/FontStyleConfig";
export class GGInitialWinCountUp extends BitmapWinCountUp {

    private _isCountUpSoundPlaying:boolean = false;
    private _hasCountUpEndSoundPlayed:boolean = false;
    private _letterSpacing:number;

    constructor(bitmapStyle:BitmapFontStyleData, letterSpacing:number = -45) {
        super({
            font:{
                name:bitmapStyle.fontName,
                size:bitmapStyle.fontSize,
            },
            align :bitmapStyle.align,
            tint: bitmapStyle.tint || 0xffffff
        });
        this._letterSpacing = letterSpacing;
    }

    protected isFontEvenWidth():boolean {
        return false;
    }

    public getCountUpAnimation(from:number, to:number, duration:number, withSound:boolean = true):Timeline {
        const oriNumber:number = Number(Number(to).toFixed(2));
        const timeline:TimelineLite = new TimelineLite();
        timeline.add([
            () => {
                this._countUp.alpha = 1;
                this._countUp.visible = true;
                if(duration > 1 && withSound) {
                    GGGameModuleConfig.soundPlayer.playSoundEffect(GGSoundConfig.COUNTUP);
                    this._isCountUpSoundPlaying = true;
                }
            },
            this._countUp.getCountUpAnimation(from, oriNumber, {duration : duration, ease : Power3.easeInOut})
        ]);

        timeline.add(() => {this.stopCountUpSound();});
        return timeline;
    }

    private stopCountUpSound():void {
        if(this._isCountUpSoundPlaying) {
            GGGameModuleConfig.soundPlayer.stopSoundEffect(GGSoundConfig.COUNTUP);
            this._isCountUpSoundPlaying = false;
            if(!this._hasCountUpEndSoundPlayed) {
                this._hasCountUpEndSoundPlayed = true;
            }
        }
    }

    public abort(endValue:number, isAborted:boolean, isBigWin:boolean):Timeline | null {
        if(isBigWin) {
            return null;
        }
        return super.abort(endValue, isAborted);
    }

    protected getAbortAnimation(endValue:number):Timeline {
        // #441
        TweenLite.killTweensOf(this._countUp);

        const timeline:TimelineLite = new TimelineLite();
        timeline.add(
            () => {
                this._countUp.alpha = 1;
                this._countUp.visible = true;
            }
        );
        return timeline;
    }

    public getEndingAnimation(endValue:number):Timeline {
        const timeline:TimelineLite = new TimelineLite({
            onComplete : () => {
                this._isCountUpSoundPlaying = false;
                this._hasCountUpEndSoundPlayed = false;
            }
        });
        timeline.add(() => this.stopCountUpSound());
        timeline.add(this._countUp.getCountUpAnimation(endValue, endValue, {duration : 0.01}));
        timeline.add(TweenLite.to(this._countUp, 0.5, {alpha : 0}), `+=0.8`); // stay a while after count up.

        return timeline;
    }
}